import { useEffect } from 'react'

/**
 * Set the CSS variable --vh to the viewport height in vh units.
 *
 * This is a workaround for a bug in Safari PWAs where the viewport height
 * is not updated correctly when the page is hidden and then shown again.
 */
function useVhUnit() {
  const iOS = /iPhone|iPad|iPod/.test(navigator.userAgent)
  const versionMatch = navigator.userAgent.match(/OS (\d+)_/)
  const majorVersion = versionMatch ? parseInt(versionMatch[1], 10) : null
  useEffect(() => {
    if (iOS && majorVersion >= 16) {
      return
    }
    const updateVh = () => {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }

    // Initial calculation
    updateVh()

    // Recalculate on resize (changes when oriented or keyboard appears)
    window.addEventListener('resize', updateVh)

    // Recalculate on pageshow/focus (handles SSO redirects and background/foreground)
    window.addEventListener('pageshow', updateVh)
    window.addEventListener('focus', updateVh)

    return () => {
      window.removeEventListener('resize', updateVh)
      window.removeEventListener('pageshow', updateVh)
      window.removeEventListener('focus', updateVh)
    }
  }, [])
}

export default useVhUnit
